import {
  compose,
  equals,
  and,
  converge,
  prop,
  head,
  split,
  defaultTo,
} from 'ramda';

import { getOfferId, getParsedSearch } from 'app/router/selectors';
import { UTM_CAMPAIGN } from 'app/router/constants/urlParameters';
import {
  OFFER_LRX,
  LRX_UTM_CAMPAIGN,
} from 'app/features/deviceActivation/constants';

const isOfferLRX = compose(
  equals(OFFER_LRX),
  compose(head, split('-')),
  defaultTo(''),
  getOfferId,
);

const isLrxUtmCampaign = compose(
  equals(LRX_UTM_CAMPAIGN),
  prop(UTM_CAMPAIGN),
  getParsedSearch,
);

const isDeviceActivated = converge(and, [isOfferLRX, isLrxUtmCampaign]);

export { isDeviceActivated };
